import React, { useContext, useState } from 'react';

import { Switch, CircularProgress } from '@material-ui/core';
import { useMediaQuery } from 'react-responsive';
import { format } from 'date-fns';
import AutoPayIcon from '@material-ui/icons/Autorenew';
import EBillIcon from '@material-ui/icons/Eco';

import { Context as AuthContext } from '../context/auth.context.js';
import { Context as InvoicesContext } from '../context/invoices.context.js';
import { Context as PortalContext } from '../context/portal.context.js';
import { Context as WalletContext } from '../context/wallet.context.js';

import DecimalsOnly from '../helpers/DemicalsOnly';
import PaymentMethod from '../helpers/PaymentMethod';
import Thousands from '../helpers/Thousands';

import AutoPayModal from './AutoPayModal';
import EinvoicingModal from './EinvoicingModal';

import { Pie, Bar, Doughnut } from 'react-chartjs-2';

const data = {
	labels: [
		'Internet',
		'Cable TV',
		'Sewer',
		'Electric',
		'Phone',
		'Water',
		'Other',
	],
	datasets: [
		{
			data: [75.0, 30.55, 33.32, 14.5, 14.95, 15.7, 50.5],
			backgroundColor: [
				'#DC021F',
				'#EE9C03',
				'#009F3D',
				'#F9F500',
				'#3E107C',
				'#0076BE',
				'#049AA5',
			],
		},
	],
};

// const options = {
// 	plugins: {
// 		legend: {
// 			display: false,
// 		},
// 	},
// 	scales: {
// 		yAxes: [
// 			{
// 				ticks: {
// 					beginAtZero: true,
// 				},
// 			},
// 		],
// 	},
// };

const SideBar = (props) => {
	const [walletEmpty, setWalletEmpty] = useState(true);
	const [wallet, setWallet] = useState({});
	const [modalOpen, setModalOpen] = useState(false);
	const [paymentMethod, setPaymentMethod] = useState('CC');
	const [eInvoicingEnabled, setEinvoicingEnabled] = useState(false);
	const { state } = useContext(AuthContext);
	const {
		paidYrToDate,
		getAutoPay,
		updateAutoPay,
		setAutoPayModalOpen,
		setEinvoicingModalOpen,
	} = useContext(InvoicesContext);

	const portalState = useContext(PortalContext);
	const invoicesState = useContext(InvoicesContext);
	const walletState = useContext(WalletContext);

	const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1000px)' });

	React.useEffect(() => {
		setEinvoicingEnabled(
			localStorage.getItem('einvoicing_enabled') === 'false'
				? false
				: true
		);

		//console.log("WALLET", walletState.state.wallet);

		//console.log(walletState);
		if (state.authenticated && portalState.state.portalHydrated) {
			paidYrToDate({
				customerID: state.customerID,
				merchantID: state.merchantID,
			});
			getAutoPay({
				customerID: state.customerID,
				merchantID: state.merchantID,
			});
		}
	}, []);

	function correctDate(d) {
		let date = new Date(d);
		return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
	}

	return (
		<div
			style={{
				...styles.container,
				width: isTabletOrMobile ? '100%' : 800,
				paddingLeft: isTabletOrMobile ? 15 : 0,
				paddingRight: isTabletOrMobile ? 15 : 25,
				marginRight: isTabletOrMobile ? 0 : 25,
				boxSizing: 'border-box',
			}}
		>
			{!isTabletOrMobile ? (
				<>
					<div style={styles.lineItem}>
						<h5 style={{ color: '#004887', fontSize: 16 }}>
						<x-lang>Account</x-lang>
						</h5>
						<h5 style={{ color: '#004887', fontSize: 16 }}>
							{state.accountNumber}
						</h5>
					</div>
					<span
						style={{
							color: 'grey',
							display: 'flex',
							alignSelf: 'flex-start',
							marginBottom: 15,
						}}
					>
						<x-lang>As of</x-lang>: {format(new Date(), 'MM/dd/yyyy')}
					</span>
				</>
			) : null}

			{isTabletOrMobile ? (
				<>
					<div
						style={{
							...styles.amountDueContainer,
							background: 'white',
							height: 'auto',
							padding: 25,
							boxSizing: 'border-box',
							border: '1px solid #e3e6e7',
							position: 'relative',
							flexDirection: 'column',
							alignItems: 'center',
						}}
					>
						<div
							style={{
								display: 'flex',
								flexDirection: 'row',
								alignItems: 'center',
								justifyContent: 'center',
								width: '100%',
								marginTop: 15,
								paddingBottom: 15,
							}}
						>
							<h3
								style={{
									color: props.theme.palette.primary.main,
									fontSize: 16,
									margin: 0,

									position: 'absolute',
									left: 25,
									top: 15,
								}}
							>
								<x-lang>Total Due</x-lang>
							</h3>
							<div
								style={{
									display: 'flex',
									flexDirection: 'row',
									fontWeight: '400',
									color: 'black',
									alignItems: 'center',
								}}
							>
								<sup style={{ fontSize: 16, marginBottom: 10 }}>
									$
								</sup>
								<span
									style={{
										...styles.amountDueText,
										color: 'black',
										fontSize: 34,
									}}
								>
									{Thousands(
										Math.trunc(invoicesState.state.totalDue)
									)}
								</span>
								<sup
									style={{
										fontSize: 16,
										marginRight: 25,
										marginBottom: 10,
									}}
								>
									{DecimalsOnly(invoicesState.state.totalDue)}
								</sup>
							</div>
							{/* <Button
                color="secondary"
                variant="contained"
                data-ipayname="submit"
                className="ipayfield"
                style={{
                  height: 40,
                  color: "white",
                  borderRadius: 25,
                }}
              >
                Pay Now
              </Button> */}
							{/* <div style={styles.divider} />*/}
						</div>
						{/* <div
              style={{
                display: "flex",
                flexDirection: "row",
                width: " 100%",
                marginTop: 25,
              }}
            >
              <AutoPayIcon
                style={{ marginLeft: 0, marginRight: 10, color: "#004887" }}
              />
              <h3
                style={{
                  color: "#2f343b",
                  display: "flex",
                  justifyContent: "center",
                  marginTop: 0,
                  marginBottom: 0,
                  fontWeight: 500,
                }}
              >
                Auto Pay
              </h3>
            </div> */}
					</div>
					{invoicesState.state.overDue === 0 ? null : (
						<div
							style={{
								...styles.amountDueContainer,
								background: 'white',
								height: 'auto',
								boxSizing: 'border-box',
								border: '1px solid #e3e6e7',
								justifyContent: 'center',
								alignItems: 'center',
								padding: 25,
								marginTop: 15,
								background: '#FCECE9',
							}}
						>
							<div
								style={{
									display: 'flex',
									flexDirection: 'row',
									fontWeight: '400',
									alignItems: 'flex-start',
									justifyContent: 'center',
								}}
							>
								<sup style={{ fontSize: 20, color: '#B00020' }}>
									$
								</sup>
								<span style={styles.overDueText}>
									{Thousands(
										Math.trunc(invoicesState.state.overDue)
									)}
								</span>
								<sup style={{ fontSize: 20, color: '#B00020' }}>
									{DecimalsOnly(invoicesState.state.overDue)}
								</sup>
							</div>
							<span
								style={{
									fontSize: 14,
									color: '#B00020',
									marginLeft: 15,
								}}
							>
								<x-lang>Overdue</x-lang>
							</span>
						</div>
					)}
				</>
			) : (
				<>
					<div
						style={{
							...styles.amountDueContainer,
							background: props.theme.palette.amountDue.main,

							border: props.theme.palette.amountDue.border,
						}}
					>
						<div
							style={{
								display: 'flex',
								flexDirection: 'row',
								fontWeight: '400',
								color: props.theme.palette.amountDue.text,
								alignItems: 'flex-start',
							}}
						>
							{!invoicesState.state.loadingInvoices ? (
								<>
									<sup style={{ fontSize: 20 }}>$</sup>
									<span
										style={{
											...styles.amountDueText,
											color: props.theme.palette.amountDue
												.text,
										}}
									>
										{Thousands(
											Math.trunc(
												invoicesState.state.totalDue
											)
										)}
									</span>
									<sup style={{ fontSize: 20, marginTop: 3 }}>
										{DecimalsOnly(
											invoicesState.state.totalDue
										)}
									</sup>
								</>
							) : (
								<CircularProgress
									size={25}
									style={{ color: 'white' }}
								/>
							)}
						</div>

						<h3
							style={{
								color: props.theme.palette.amountDue.text,
								marginLeft: 20,
								fontWeight: '300',
							}}
						>
							<x-lang>Due</x-lang>
						</h3>
					</div>
					<div style={styles.ytdContainer}>
						{state.externalProvider != "daffron" && (
						<>
						<div
							style={{
								width: '100%',
								display: 'flex',
								flexDirection: 'column',
								textAlign: 'center',
							}}
						>
							<div
								style={{
									display: 'flex',
									flexDirection: 'row',
									fontWeight: '400',
									alignItems: 'flex-start',
									justifyContent: 'center',
									marginBottom: 10,
								}}
							>
							{!invoicesState.state.loadingInvoices ? (
									<>
										<sup style={{ fontSize: 20 }}>$</sup>
										<span style={styles.yearText}>
											{Thousands(
												Math.trunc(
													invoicesState.state
														.paidYrToDate
												)
											)}
										</span>
										<sup style={{ fontSize: 20 }}>
											{DecimalsOnly(
												invoicesState.state.paidYrToDate
											)}
										</sup>
									</>
								) : (
									<CircularProgress
										size={25}
										style={{ color: 'black' }}
									/>
								)}
							</div>
							<span style={{ fontSize: 18 }}><x-lang>Paid YTD</x-lang></span>
						</div>
						<div
							style={{
								width: 1,
								height: '100%',
								background: '#e3e6e7',
							}}
						/>
						</>
						)}
						<div
							style={{
								width: '100%',
								display: 'flex',
								flexDirection: 'column',
								textAlign: 'center',
							}}
						>
							<div
								style={{
									display: 'flex',
									flexDirection: 'row',
									fontWeight: '400',
									alignItems: 'flex-start',
									justifyContent: 'center',
									marginBottom: 10,
								}}
							>
								{!invoicesState.state.loadingInvoices ? (
									<>
										<sup
											style={{
												fontSize: 20,
												color: '#B00020',
											}}
										>
											$
										</sup>
										<span style={styles.overDueText}>
											{Thousands(
												Math.trunc(
													invoicesState.state.overDue
												)
											)}
										</span>
										<sup
											style={{
												fontSize: 20,
												color: '#B00020',
											}}
										>
											{DecimalsOnly(
												invoicesState.state.overDue
											)}
										</sup>
									</>
								) : (
									<CircularProgress
										size={25}
										style={{ color: 'black' }}
									/>
								)}
							</div>
							<span style={{ fontSize: 18, color: '#B00020' }}>
							<x-lang>Overdue</x-lang>
							</span>
						</div>
					</div>
				</>
			)}

			{!isTabletOrMobile ? <div style={styles.divider} /> : null}

			{state.authenticated &&
			state.isFullAccount &&
			portalState.state.allowAutoPay ? (
				<div style={{ ...styles.autoPayContainer, padding: 15 }}>
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							alignItems: 'center',
							justifyContent: 'space-between',
							width: '100%',
						}}
					>
						<div style={{ display: 'flex', flexDirection: 'row' }}>
							<AutoPayIcon
								style={{
									marginLeft: isTabletOrMobile ? 10 : 10,
									marginRight: 25,
									color: '#004887',
								}}
							/>
							<h3
								style={{
									color: '#2f343b',
									display: 'flex',
									justifyContent: 'center',
									marginTop: 0,
									marginBottom: 0,
									fontWeight: 500,
								}}
							>
								<x-lang>Auto Pay</x-lang>
							</h3>
						</div>

						<Switch
							checked={invoicesState.state.autoPay.autoPayEnabled}
							onChange={() => {
								if (
									invoicesState.state.autoPay.autoPayEnabled
								) {
									updateAutoPay({
										paymentMethod:
											invoicesState.state.autoPay
												.paymentMethod === 'ach'
												? 'ACH'
												: 'CC',
										state: 'off',
									});
								} else {
									setAutoPayModalOpen(true);
								}
							}}
							color="secondary"
							name="checkedB"
							inputProps={{ 'aria-label': 'primary checkbox' }}
						/>
					</div>
					{invoicesState.state.autoPay.autoPayEnabled ? (
						<div
							style={{
								marginTop: 25,
								width: '100%',
								marginLeft: isTabletOrMobile ? 25 : 45,
							}}
						>
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									alignItems: 'flex-start',
									justifyContent: 'flex-start',
									width: '100%',
									marginBottom: 20,
								}}
							>
								<span
									style={{
										marginBottom: 8,
										color: '#627278',
									}}
								>
									<x-lang>Payment Method</x-lang>
								</span>
								<div
									style={{
										display: 'flex',
										flexDirection: 'row',
										alignItems: 'center',
									}}
								>
									{PaymentMethod(
										invoicesState.state.autoPay
											.paymentMethod
									)}
									<span style={{ marginLeft: 10 }}>
									<x-lang>ending in</x-lang> ...
										{
											invoicesState.state.autoPay
												.paymentLastFour
										}
									</span>
								</div>
							</div>
							{invoicesState.state.autoPay.nextDueDate === '' ||
							!invoicesState.state.autoPay.nextDueDate ? (
								<div
									style={{
										display: 'flex',
										flexDirection: 'column',
										alignItems: 'flex-start',
										justifyContent: 'flex-start',
										width: '100%',
										marginBottom: 25,
									}}
								>
									<span
										style={{
											marginBottom: 8,
											color: '#627278',
										}}
									>
										<x-lang>No payments scheduled</x-lang>
									</span>
								</div>
							) : (
								<div
									style={{
										display: 'flex',
										flexDirection: 'column',
										alignItems: 'flex-start',
										justifyContent: 'flex-start',
										width: '100%',
										marginBottom: 25,
									}}
								>
									{/* <span
										style={{
											marginBottom: 8,
											color: '#627278',
										}}
									>
										Next Payment
									</span>
									<div
										style={{
											display: 'flex',
											flexDirection: 'row',
											alignItems: 'center',
										}}
									>
										<span>
											{format(
												correctDate(
													invoicesState.state.autoPay
														.nextDueDate
												),
												'MM/dd/yyyy'
											)}
										</span>
									</div> */}
								</div>
							)}
						</div>
					) : null}
				</div>
			) : null}
			{/* <div
				style={{
					background: 'white',
					borderRadius: 5,
					border: '1px solid #ddd',
					marginTop: 25,
				}}
			>
				<Pie data={data} style={{ padding: 25 }} />
			</div> */}

			{/* {portalState.state.enable_einvoicing ? (
        <div style={{ ...styles.eInvoicingContainer, padding: 15 }}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <EBillIcon
                style={{
                  marginLeft: isTabletOrMobile ? 10 : 10,
                  marginRight: 25,
                  color: "#004887",
                }}
              />
              <h3
                style={{
                  color: "#2f343b",
                  display: "flex",
                  justifyContent: "center",
                  marginTop: 0,
                  marginBottom: 0,
                  fontWeight: 500,
                }}
              >
                Enroll in Paperless E-billing
              </h3>
            </div>

            <Switch
              checked={eInvoicingEnabled}
              onChange={() => {
                if (eInvoicingEnabled) {
                  setEinvoicingEnabled(false);
                  localStorage.setItem("einvoicing_enabled", "false");
                } else {
                  // setAutoPayModalOpen(true);
                  setEinvoicingModalOpen(true);
                }
              }}
              color="secondary"
              name="checkedB"
              inputProps={{ "aria-label": "primary checkbox" }}
            />
          </div>
        </div>
      ) : null} */}
			{invoicesState.state.autoPayModalOpen ? <AutoPayModal /> : null}
			{invoicesState.state.eInvoicingModalOpen ? (
				<EinvoicingModal setEinvoicingEnabled={setEinvoicingEnabled} />
			) : null}
		</div>
	);
};

const styles = {
	container: {
		boxShadow: '20px 0 21px -21px rgba(0,0,0,.14)',
		padding: 15,
		boxSizing: 'border-box',
	},
	amountDueContainer: {
		width: '100%',
		height: 80,
		borderRadius: 5,
		backgroundColor: '#004887',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	ytdContainer: {
		width: '100%',
		height: 120,
		borderRadius: 5,
		backgroundColor: 'white',
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		border: '1px solid #e3e6e7',
		marginTop: 15,
		padding: 15,
		boxSizing: 'border-box',
	},
	autoPayContainer: {
		width: '100%',
		borderRadius: 5,
		backgroundColor: 'white',
		flexDirection: 'column',
		display: 'flex',
		alignItems: 'center',
		border: '1px solid #e3e6e7',
		marginTop: 15,

		boxSizing: 'border-box',
	},
	eInvoicingContainer: {
		width: '100%',
		borderRadius: 5,
		backgroundColor: 'white',
		flexDirection: 'column',
		display: 'flex',
		alignItems: 'center',
		border: '1px solid #e3e6e7',
		marginTop: 15,

		boxSizing: 'border-box',
	},
	amountDueText: {
		color: 'white',
		fontSize: 40,
		fontFamily:
			'gotham-rounded-book,arial,helvetica,tahoma,verdana,sans-serif',
	},
	yearText: {
		fontSize: 30,
		fontFamily:
			'gotham-rounded-book,arial,helvetica,tahoma,verdana,sans-serif',
	},
	overDueText: {
		color: '#B00020',
		fontSize: 30,
		fontFamily:
			'gotham-rounded-book,arial,helvetica,tahoma,verdana,sans-serif',
	},
	lineItem: {
		width: '100%',
		height: 50,
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
	},
	divider: {
		width: '100%',
		height: 1,
		background: '#e3e6e7',
		marginTop: 25,
		marginBottom: 25,
	},
	dividerMobile: {
		width: 1,
		height: 75,
		background: '#e3e6e7',
		marginRight: 50,
		marginLeft: 50,
	},
};

export default SideBar;
